var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3V2Z",
    fill: "currentColor"
  })));
};
export { SvgFacebook as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xOCAySDE1QzEzLjY3MzkgMiAxMi40MDIxIDIuNTI2NzggMTEuNDY0NSAzLjQ2NDQ3QzEwLjUyNjggNC40MDIxNSAxMCA1LjY3MzkyIDEwIDdWMTBIN1YxNEgxMFYyMkgxNFYxNEgxN0wxOCAxMEgxNFY3QzE0IDYuNzM0NzggMTQuMTA1NCA2LjQ4MDQzIDE0LjI5MjkgNi4yOTI4OUMxNC40ODA0IDYuMTA1MzYgMTQuNzM0OCA2IDE1IDZIMThWMloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";